import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import RedButton from 'components/buttons/RedButton';
import { H4 } from 'components/typography/Headers';
import { AddItemContextProps, AddItemProvider, useAddItem } from 'features/add-item/context/AddItemProvider';

import ItemSummaryForm from './components/ItemSummaryForm';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 80vh;
  width: 535px;

  ${theme.mq.phone} {
    width: 100%;
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
  padding: 0 30px;
  scrollbar-gutter: stable both-edges;

  ${theme.mq.phone} {
    padding: 0 10px;
  }
`;

const SaveButton = styled(RedButton)`
  height: 46px;
  width: unset;
  margin: 36px 40px 0 40px;

  ${theme.mq.phone} {
    margin: 36px 20px 0 20px;
  }
`;

const EditItemForm = () => {
  const { t } = useTranslation('addItem');
  const { save, isFormValid, isSaving, isLoading } = useAddItem();

  return (
    <Container data-testid={'edit-item-form'}>
      <H4 data-testid={'form-header'}>{t('edit-form.header')}</H4>
      <ContentWrapper>
        <ItemSummaryForm />
      </ContentWrapper>
      {!isSaving && !isLoading && (
        <SaveButton onClick={save} disabled={!isFormValid}>
          {t('common:save')}
        </SaveButton>
      )}
    </Container>
  );
};

const EditItemFormWithContext = ({ item, supportedCampaign, onItemSaved }: AddItemContextProps) => {
  return (
    <AddItemProvider item={item} supportedCampaign={supportedCampaign} onItemSaved={onItemSaved}>
      <EditItemForm />
    </AddItemProvider>
  );
};

export default EditItemFormWithContext;
